import React from 'react';
import { Button } from 'equal-ds-ui';
import type { AdminUserTableRow } from '../../../types/admin-users';

export type ApprovalAction = 'APPROVE' | 'REJECT';

export interface AdminUserApprovalDialogProps {
  user: AdminUserTableRow | null;
  action: ApprovalAction;
  isOpen: boolean;
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
  isProcessing?: boolean;
}

export const AdminUserApprovalDialog: React.FC<AdminUserApprovalDialogProps> = ({
  user,
  action,
  isOpen,
  onConfirm,
  onClose,
  isProcessing = false,
}) => {
  if (!isOpen || !user) {
    return null;
  }

  const isApprove = action === 'APPROVE';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="relative z-10 w-full max-w-md bg-white rounded-xl shadow-xl border border-border-default p-6 space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-text-primary">
            {isApprove ? 'Approve User' : 'Reject User'}
          </h3>
          <p className="text-sm text-text-secondary mt-1">
            {isApprove
              ? 'Approving will activate the account and notify the user.'
              : 'Rejecting will notify the requestor and keep the account inactive.'}
          </p>
        </div>

        <div className="bg-background-tertiary border border-border-default rounded-lg px-4 py-3 text-sm text-text-secondary">
          <div>
            <span className="font-medium text-text-primary">Name:</span> {user.name}
          </div>
          <div>
            <span className="font-medium text-text-primary">Email:</span> {user.email}
          </div>
          <div>
            <span className="font-medium text-text-primary">Current status:</span> {user.status}
          </div>
        </div>

        <div className="flex items-center justify-end gap-3">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={isProcessing}
            className="bg-white text-text-primary border border-border-default hover:bg-background-tertiary"
          >
            Cancel
          </Button>
          <Button
            variant={isApprove ? 'primary' : 'secondary'}
            className={isApprove ? '' : 'bg-red-600 hover:bg-red-700 text-white'}
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {isApprove ? 'Approve' : 'Reject'}
          </Button>
        </div>
      </div>
    </div>
  );
};
